import { z } from 'zod';

/** One admin-curated exemplary conversation (successful_runs row joined with
 *  its conversation). */
export const SuccessfulRunSchema = z.object({
  conversationId: z.string(),
  note: z.string(),
  tags: z.array(z.string()),
  createdBy: z.string(),
  createdAt: z.string(),
  userEmail: z.string().nullable(),
  title: z.string().nullable(),
});
export type SuccessfulRun = z.infer<typeof SuccessfulRunSchema>;

export const SuccessfulRunListSchema = z.object({
  runs: z.array(SuccessfulRunSchema),
});

export const SuccessfulRunLookupSchema = z.object({
  run: SuccessfulRunSchema.nullable(),
});

export const SuccessfulRunMutationSchema = z.object({
  ok: z.literal(true),
});
